import * as allChains from 'viem/chains';
export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
export async function sleepUntil(thisObject, condition, timeoutMs = 2000, checkEveryMs = 100) {
    let currentMs = 0;
    while (currentMs <= timeoutMs) {
        const result = condition(thisObject);
        if (result) {
            return result;
        }
        await sleep(checkEveryMs);
        currentMs += checkEveryMs;
    }
    return undefined;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function invariant(cond, message) {
    if (!cond) {
        throw new Error(message);
    }
}
export function staticAssertNever(x) {
    throw new Error('Unexpected object: ', x);
}
// https://chainlist.org/
// https://eips.ethereum.org/EIPS/eip-155#list-of-chain-ids
export function getChainName(chainId) {
    const chain = Object.values(allChains).find((x) => x.id === chainId);
    if (chain) {
        return chain.name;
    }
    throw new Error(`ChainId ${chainId} not found`);
}
export async function retryOperation(operation, options = {}) {
    const maxRetries = options.maxRetries ?? 3;
    const getRetryDelay = options.getRetryDelay ??
        ((retryCount) => {
            return Math.min(1000 * 2 ** retryCount, 20000); // 2, 4, 8 seconds if max retries is 3
        });
    let retryCount = 0;
    // eslint-disable-next-line no-constant-condition
    while (true) {
        try {
            return await operation();
        }
        catch (error) {
            retryCount++;
            options.onError?.(error, retryCount);
            if (retryCount > maxRetries) {
                throw error;
            }
            const retryDelay = getRetryDelay(retryCount);
            options.onRetry?.(retryCount);
            await new Promise((resolve) => setTimeout(resolve, retryDelay));
        }
    }
}
//# sourceMappingURL=towns-utils.js.map